export default function Arrowleft() {
return(
<svg xmlns="http://www.w3.org/2000/svg" width="62" height="16" viewBox="0 0 62 16" fill="none">
  <path d="M0.293137 7.53948C-0.0973854 7.93 -0.0973854 8.56316 0.293137 8.95369L6.6571 15.3176C7.04762 15.7082 7.68079 15.7082 8.07131 15.3176C8.46184 14.9271 8.46184 14.294 8.07131 13.9034L2.41446 8.24658L8.07131 2.58973C8.46184 2.1992 8.46184 1.56604 8.07131 1.17551C7.68079 0.78499 7.04762 0.78499 6.6571 1.17551L0.293137 7.53948ZM61.1855 7.24658L1.00024 7.24658V9.24658L61.1855 9.24658V7.24658Z" fill="black"/>
</svg>
)
}
